<template>
  <div class="flex flex-col flex-shrink-0 mx-4 py-8 text-center bg-white border-2 border-gray-200 rounded-lg dark:bg-gray-800 dark:border-gray-700 plan-O" style="height:385px; width:220px;">
    <div class="text-center">
        <h2 class="font-semibold uppercase text-yellow">
          {{ plansListOData.plan_o_title }}
        </h2>
        <!-- <span class="text-gray-500">適合企業</span> -->
    </div>
    <div class="text-gray-700 text-center font-mono flex flex-wrap justify-center content-center py-4 my-4 bg-plan-O">
      <div class="text-white">
        <p class="text-3xl">{{ plansListOData.plan_o_label_amount }}<span v-if="plansListOData.is_amount" class="text-sm ml-2">/{{lang['components']['Plan']['PlanC']['time_unit']}}</span></p>
        <!--<p v-if="plansListOData.is_amount" class="text-sm">per month</p>-->
      </div>
    </div>
    <ul class="flex-1 space-y-2 text-gray-500 dark:text-gray-400 text-sm">
      <li v-for="(item, index) in description" class="border-b">
          <div v-html="item"></div>
      </li>
    </ul>
    <!--<button v-if="plansListOData.plan_o_show" class="rounded-full bg-plan-O mx-16 py-2 mt-12" :disabled="isDisabled" @click="handleChickPlan(plansListOData.plan_id, 'O')">
      {{ plansListOData.plan_o_text }}
    </button>-->
    <button v-if="plansListOData.plan_o_show" class="rounded-2xl bg-plan-O mx-16 p-2 mt-auto text-sm" @click="handleChickPlan(plansListOData.plan_id, 'O', '', 'fb')">
      {{ plansListOData.plan_o_text }}
    </button>
    <button v-else-if="!plansListOData.planHaveBind" class="rounded-2xl bg-plan-O mx-16 p-2 mt-auto text-sm" @click="handleChickPlan(plansListOData.plan_id, 'O', '', 'fb')">
      {{lang['components']['Plan']['PlanC']['pay_use']}}
    </button>
    <button
      v-else
      class="rounded-2xl bg-plan-O mx-16 p-2 mt-auto text-sm"
      v-if="isExpiredData && (plansListOData.plan_o_text == '使用中' || plansListOData.plan_o_text == 'Using')"
      @click="handleChickPlan(plansListOData.plan_id, 'O', 'payAgain', 'fb')"
    >
      {{lang['components']['Plan']['PlanC']['plan_item_payagain_button_text']}}
    </button>
  </div>
</template>

<script>
export default {
  name: 'PlanO',
  props: {
    handleChickPlan: {
      type: Function,
      default: () => ({})
    },
    plansListO:{
      type:Object,
      required:true
    },
    isExpired: {
      type: Boolean
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      payError: true
    };
  },
  computed: {
    plansListOData: {
      get: function () {
        return this.plansListO
      },
      set: function (value) {
        this.$emit('update:plansListOData', value)
      },
    },
    isExpiredData: {
      get: function () {
        return this.isExpired
      },
      set: function (value) {
        this.$emit('update:isExpiredData', value)
      },
    },
    description: function() {
       return this.plansListO.plan_o_description
    },
    isDisabled: function() {
       return this.plansListO.plan_o_disable
    }
  }
}
</script>

<style lang="scss" scope>
  .plan-O {
    &:hover {
      border: 2px #E8C177 solid;
    }
  }
</style>